var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"md-layout md-gutter md-size-100",style:(_vm.height)},[_c('div',{staticClass:"md-layout-item md-size-100 md-layout md-gutter md-alignment-center-center"},[_c('md-progress-spinner',{attrs:{"md-diameter":100,"md-stroke":10,"md-mode":"indeterminate"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }